import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import ProductVideo from "../product-video/productVideo";

export default ({ node }) => {
  const { productSectionVideo } = node;
  return (
    <Box>
      {productSectionVideo && productSectionVideo.length > 0 ? (
        <Grid container>
          {productSectionVideo.map((item) => {
            return (
              <Grid item xs={12} sm={12} md={4}>
                <ProductVideo node={item} />
              </Grid>
            );
          })}
        </Grid>
      ) : null}
    </Box>
  );
};
